import type { RpSectionOf } from '@mlm/shared';
import { useRpCtx } from '../context';
import { RollingCountdown, RpCountdownBlocks } from '../countdown';

/**
 * A countdown placed anywhere on the page, as opposed to the page-level timer
 * banner that always sits at the very top.
 *
 * The per-visitor anchor is keyed by PAGE id + section id, not by URL: the
 * default page is reachable both bare (`/r/<code>`) and via its slug, and a
 * URL-keyed anchor would restart the clock when a visitor moved between the two.
 * Without a page id (the admin preview) it falls back to the section id alone,
 * which is fine — nobody is being persuaded by the preview.
 */
export function RpCountdown({ section }: { section: RpSectionOf<'countdown'> }) {
  const ctx = useRpCtx();
  const c = section.config;
  const storageKey = `mlm.rp.sec.${ctx.pageId ?? 'preview'}.${section.id}`;

  if (c.variant === 'blocks') {
    return <RpCountdownBlocks periodHours={c.hours} label={c.label} storageKey={storageKey} />;
  }
  return <RollingCountdown periodHours={c.hours} label={c.label} storageKey={storageKey} />;
}
